"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import Cookies from "js-cookie";

import { notifyOestraLpRedirectCookiesChanged } from "~/components/features/quiz/oestraLpRedirect";
import { isOestraLpPath, LP_VISITED_COOKIE, LP_VISITED_COOKIE_VALUE } from "~/constants/oestraLandingPages";

const LpVisitCookie = () => {
    const pathname = usePathname();

    useEffect(() => {
        if (!isOestraLpPath(pathname)) return;

        Cookies.set(LP_VISITED_COOKIE, LP_VISITED_COOKIE_VALUE, { path: "/", sameSite: "lax" });
        notifyOestraLpRedirectCookiesChanged();
    }, [pathname]);

    return null;
};

export default LpVisitCookie;
